'use client';

import { useTranslations, useLocale } from 'next-intl';
import { NotFoundContent } from '@/components/NotFoundContent';

export default function NotFound() {
    const t = useTranslations('common');
    const locale = useLocale();

    return (
        <NotFoundContent
            title={t('notFound.title')}
            description={t('notFound.description')}
            backHomeLabel={t('notFound.backHome')}
            goBackLabel={t('notFound.goBack')}
            homeHref={`/${locale}`}
            isRTL={locale === 'ar'}
        />
    );
}
